export const mutations = {
  DRAWER_RESET: "DRAWER_RESET",
  TOGGLE_DRAWER: "DRAWER_TOGGLE_DRAWER",
  UPDATE_WINDOW_SIZE: "DRAWER_UPDATE_WINDOW_SIZE",
  SET_DISPLAY_FEEDBACK: "SET_DISPLAY_FEEDBACK",
}

export const actions = {
}
